import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRightIcon, BrushIcon, LayersIcon, SquareIcon } from "lucide-react";
const tags = [{
  label: "Peinture",
  Icon: BrushIcon
}, {
  label: "Vitrerie",
  Icon: SquareIcon
}, {
  label: "Façades",
  Icon: LayersIcon
}];
export function Hero() {
  const reduce = useReducedMotion();
  return <section aria-labelledby="hero-title" className="px-3 lg:px-5" data-id="element-82" data-mp="aotnmhurdi2p">
      <div className="mx-auto grid max-w-[1440px] gap-4 lg:grid-cols-2 lg:gap-5" data-id="element-83" data-mp="5pgsl9tqh4p1">
        <div className="flex flex-col justify-between rounded-3xl bg-surface px-6 py-12 sm:px-10 lg:px-14 lg:py-16" data-id="element-84" data-mp="5rjo29dnnq15">
          <div data-id="element-85" data-mp="3rwou211j8rfs">
            <h1 id="hero-title" className="text-[40px] font-bold leading-[1.05] tracking-tight text-ink sm:text-6xl xl:text-[68px]" data-id="element-86" data-mp="3rx6tt7nelnsg">
              Des murs nets,
              <br data-id="element-87" data-mp="1v2112t4fdnms" />
              des façades
              <br data-id="element-88" data-mp="1q528wg4bnqr8" />
              <span className="text-accent" data-id="element-89" data-mp="1q6lmfyylfnpb">qui durent.</span>
            </h1>
            <p className="mt-7 max-w-md text-lg leading-relaxed text-muted" data-id="element-90" data-mp="1mw2tj9yf4g54">
              Artisan peintre et vitrier à Meaux. Peinture intérieure et extérieure, vitrerie et enduits de façade — un seul interlocuteur, du devis à la dernière finition.
            </p>
            <div className="mt-9 flex flex-wrap gap-3" data-id="element-91" data-mp="1hx9irpain38n">
              <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent px-6 py-3.5 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-92" data-mp="1hxrln4roofpj">
                Demander un devis gratuit
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="20uiyowgmtyl5" />
              </Link>
              <a href="#prestations" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-6 py-3.5 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-ink-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-94" data-mp="2ok51dtw7qvxw">
                Nos prestations
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="2u6dtwcaijjuo" />
              </a>
            </div>
          </div>

          <dl className="mt-14 grid grid-cols-2 gap-6 border-t border-line pt-8 sm:max-w-lg" data-id="element-96" data-mp="2paq7u5rbv6te">
            <div data-id="element-97" data-mp="2kau5eaya3nfy">
              <dt className="text-sm text-muted" data-id="element-98" data-mp="2kbdi9d92nln4">Basé à</dt>
              <dd className="mt-1 text-base font-bold text-ink" data-id="element-99" data-mp="2fi109lywed3c">Meaux, Seine-et-Marne</dd>
            </div>
            <div data-id="element-100" data-mp="2ak942fr804tc">
              <dt className="text-sm text-muted" data-id="element-101" data-mp="2ahn1yvn3mhii">Devis</dt>
              <dd className="mt-1 text-base font-bold text-ink" data-id="element-102" data-mp="26j5qy10k4mvt">Gratuit, sur visite</dd>
            </div>
          </dl>
        </div>

        <div className="relative min-h-[520px] overflow-hidden rounded-3xl bg-surface lg:min-h-[680px]" data-id="element-103" data-mp="21l48niaygrle">
          <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/22050ce4-41ed-4e54-84b7-61b70a86e4b2.jpg" alt="Artisan peintre appliquant une peinture blanc cassé au rouleau dans un appartement lumineux" className="absolute inset-0 h-full w-full object-cover" initial={reduce ? false : {
          opacity: 0,
          scale: 1.03
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-104" data-mp="1wm1bsl54proi" />

          <ul className="absolute left-3 top-3 flex flex-wrap gap-2" data-id="element-105" data-mp="3ufwt3djpkclf">
            {tags.map(({
            label,
            Icon
          }) => <li key={label} className="flex items-center gap-2 rounded-full bg-ink/70 px-4 py-2 text-sm font-semibold text-white backdrop-blur" data-id="element-106" data-mp="2ccmw313a5l8">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="74e1hvlqc8ef" />
                {label}
              </li>)}
          </ul>

          <div className="absolute inset-x-3 bottom-3 grid gap-3 sm:grid-cols-2" data-id="element-108" data-mp="3arwg521rfo0a">
            <div className="rounded-2xl bg-white p-6" data-id="element-109" data-mp="3aptefkr8w6fq">
              <p className="text-3xl font-bold tracking-tight text-ink" data-id="element-110" data-mp="2rocfn09gtjfv">3 métiers</p>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-111" data-mp="2mozj1nssky03">Peinture, vitrerie et enduits réalisés par le même artisan.</p>
            </div>
            <div className="rounded-2xl bg-white p-6" data-id="element-112" data-mp="31f748ba6ov4h">
              <p className="text-3xl font-bold tracking-tight text-ink" data-id="element-113" data-mp="2wm457nmn0tgw">Chantier propre</p>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-114" data-mp="3ad98r0t4m5wi">Sols et mobilier protégés, rendu nettoyé.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}